import "./_style.css"
import {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";
import BreadCrumbs from "../../components/BreadCrumbs";
import Paper from '@mui/material/Paper';
import {useParams} from "react-router-dom";
import Footer from "../../components/Footer";
import ReportItem from "./ReportItem"
import * as React from "react";


export default function ReportsMain() {
    let {user, logoutUser, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    const {prjid} = useParams()

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Projects', 'link': '../../projects/1'},
        {'name': 'Feed reports', 'link': ''}
    ]

    const [reportsData, setReportsData] = useState({})

    useEffect(() => {
        getFeedReports()
    }, [])

    let getFeedReports = async () => {
        let response = await fetch(`${serverIP}/getfeedreports/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify({projUID: prjid}),
        })
        let data = await response.json()

        if (response.status === 200) {
            setReportsData(data)
            // reportsData.current = data

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const reportItems = Object.values(reportsData).map((item, index) => {
            return <ReportItem key={index} reportData={item}/>
        }
    )

    return (
        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>
            <div style={{minHeight: "90vh"}}>

                <div className="prj-reports-grid-header">
                    <div>Name</div>
                    <div>Format</div>
                    <div>Size</div>
                    <div>Date</div>
                </div>


                <div className="prj-reports-container">



                    {reportItems}
                    {/*<ReportItem reportData={repDataSample}/>*/}
                    {/*<ReportItem reportData={repDataSample}/>*/}
                </div>

            </div>

            <Footer/>
        </>
    )
}